<div class="row ng-scope">
  <div class="col-12">

    <div class="row form-group">
      <label class="control-label col-3">{{'Tên phụ huynh' | translate}}</label>
      <div class="col-9">
        <input type="text" #mafocus [autofocus] tabIndex="1" class="form-control" placeholder="" [(ngModel)]="doituongSelect.TenPhuHuynh">
      </div>
    </div>
    <div class="row form-group">
      <label class="control-label col-3">{{'Điện thoại' | translate}}</label>
      <div class="col-9">
        <input type="text" tabIndex="2" class="form-control" placeholder="" [(ngModel)]="doituongSelect.DienThoai">
      </div>
    </div>
    <div class="row form-group">
      <label class="control-label col-3">{{'Hình thức thanh toán' | translate}}</label>
      <div class="col-9">
        <ng-select #slCapTren
                   class="twcollong"
                   autofocus
                   [tabIndex]="3"
                   [openOnEnter]="false"
                   [items]="inputhinhthucthanhtoans"
                   bindValue="Id"
                   bindLabel="Ten"
                   notFoundText="Không có dữ liệu"
                   [searchFn]="comboSearchFn"
                   [(ngModel)]="doituongSelect.HinhThucThanhToan">
          <ng-template ng-option-tmp let-item="item">

            <div class="rTableRow">
              <div class="rTableCell rTableCell-2">{{item.Ten}}</div>
            </div>

          </ng-template>
        </ng-select>
      </div>
    </div>

    <div class="row form-group" *ngIf="doituongSelect.HinhThucThanhToan==0">
      <label class="control-label col-3">{{'Tỉnh/TP' | translate}}</label>
      <div class="col-9">
        <ng-select #slCapTren
                   class="twcollong"
                   autofocus
                   [tabIndex]="10"
                   [openOnEnter]="false"
                   [items]="inputtinhs"
                   bindValue="Id"
                   bindLabel="Ten"
                   notFoundText="Không có dữ liệu"
                   [searchFn]="comboSearchFn"
                   (change)="changeTinh($event)"
                   [(ngModel)]="doituongSelect.TinhId">
          <ng-template ng-option-tmp let-item="item">

            <div class="rTableRow">
              <div class="rTableCell rTableCell-2">{{item.Ten}}</div>
            </div>

          </ng-template>
        </ng-select>
      </div>
    </div>

    <div class="row form-group" *ngIf="doituongSelect.HinhThucThanhToan==0">
      <label class="control-label col-3">{{'Quận/Huyện' | translate}}</label>
      <div class="col-9">
        <ng-select #slCapTren
                   class="twcollong"
                   autofocus
                   [tabIndex]="11"
                   [openOnEnter]="false"
                   [items]="inputhuyens"
                   bindValue="Id"
                   bindLabel="Ten"
                   notFoundText="Không có dữ liệu"
                   [searchFn]="comboSearchFn"
                   (change)="changeHuyen($event)"
                   [(ngModel)]="doituongSelect.HuyenId">
          <ng-template ng-option-tmp let-item="item">

            <div class="rTableRow">
              <div class="rTableCell rTableCell-2">{{item.Ten}}</div>
            </div>

          </ng-template>
        </ng-select>
      </div>
    </div>
    <div class="row form-group" *ngIf="doituongSelect.HinhThucThanhToan==0">
      <label class="control-label col-3">{{'Xã/Phường' | translate}}</label>
      <div class="col-9">
        <ng-select #slCapTren
                   class="twcollong"
                   autofocus
                   [tabIndex]="12"
                   [openOnEnter]="false"
                   [items]="inputxas"
                   bindValue="Id"
                   bindLabel="Ten"
                   notFoundText="Không có dữ liệu"
                   [searchFn]="comboSearchFn"
                   [(ngModel)]="doituongSelect.XaId">
          <ng-template ng-option-tmp let-item="item">

            <div class="rTableRow">
              <div class="rTableCell rTableCell-2">{{item.Ten}}</div>
            </div>

          </ng-template>
        </ng-select>
      </div>
    </div>

    <div class="row form-group" *ngIf="doituongSelect.HinhThucThanhToan==0">
      <label class="control-label col-3">{{'Địa chỉ chi tiết' | translate}}</label>
      <div class="col-9">
        <input type="text" tabIndex="12" class="form-control" placeholder="" [(ngModel)]="doituongSelect.DiaChiChiTiet">
      </div>
    </div>
    <div class="row form-group" *ngIf="doituongSelect.HinhThucThanhToan==0">
      <label class="control-label col-3">{{'Ghi chú' | translate}}</label>
      <div class="col-9">
        <input type="text" tabIndex="13" class="form-control" placeholder="" [(ngModel)]="doituongSelect.GhiChu">
      </div>
    </div>

    <div class="row form-group" *ngIf="tudanhsach==0 && doituongSelect.HinhThucThanhToan==1">
      <div class="col-12">
        <div class="info" style="background-color:white" [innerHtml]="transformYourHtml(doituongSelect.NoiDungChuyenKhoan)">
        </div>
      </div>
    </div>

    <div class="row form-group" *ngIf="tudanhsach==1">
      <label class="control-label col-3">{{'Nội dung' | translate}}</label>
      <div class="col-9">
        <ejs-richtexteditor style="background-color:white" height='250px' #toolsRTE id='alltoolRTE_ch' [toolbarSettings]='tools' [showCharCount]='true' [(value)]='doituongSelect.NoiDungChuyenKhoan'
                            [maxLength]='maxLength' [fileManagerSettings]='fileManagerSettings' [quickToolbarSettings]='quickToolbarSettings'
                            (actionBegin)='handleFullScreen($event)' (actionComplete)='actionCompleteHandler($event)'>
        </ejs-richtexteditor>

      </div>
    </div>








  </div>

</div>

<div class="modal-footer" style="display: flex;justify-content: space-between;">
  <div style="display:flex;">
    <!--<div class="checkbox c-checkbox">
      <label>
        <input tabIndex="20" type="checkbox" [(ngModel)]="doituongSelect.TrangThaiXuLy" />
        <span class="fa fa-check"></span> Đã xử lý xong
      </label>
    </div>-->
  </div>

  <div class="">
    <button style="float:left !important" class="mb-1 mr-1 btn btn-secondary" (click)="closeModal()" title="">{{'Hủy bỏ' | translate}}</button>
    <button style="float:left !important" type="submit" (click)="saveproduct()" title="" class="mb-1 mr-1 btn btn-primary">{{'Xác nhận' | translate}}</button>
  </div>

</div>


<!--<div id='target' class="control-section">
  <ejs-dialog #dialogObj id='dialog' [visible]='visible' [header]='dialogHeader' [animationSettings]='animationSettings' [showCloseIcon]='showCloseIcon' (open)="dialogOpen()" (close)="dialogClose()"
              [target]='target' [width]='dialogWidth'>
    <ejs-filemanager #filemanagerObj id='filemanager' (beforeSend)="OnbeforeSend($event)"
                     [ajaxSettings]='ajaxSettings' [toolbarSettings]='toolbarSettings'
                     [contextMenuSettings]='contextMenuSettings'
                     [allowMultiSelection]='false' (fileOpen)="onFileOpen($event)">
    </ejs-filemanager>
  </ejs-dialog>
</div>-->
